@if (isLoading()) {
    <mat-progress-bar mode="indeterminate" class="loading-bar"></mat-progress-bar>
  }